import { useQuery } from "@apollo/client";
import { SITE_CONFIG_REGION_CONTACTS_QUERY } from "Services/queries";

const useRegionContacts = () => {
	return useQuery(SITE_CONFIG_REGION_CONTACTS_QUERY);
};

export default useRegionContacts;
